// login form
$('body').on('submit', '.login form', function() {
    var $this = $(this);
    var fields = $this.serializeArray();
    fields[fields.length] = { name: '_token', value: $('meta[name="csrf-token"]').attr('content') };
    
    var error = false;

    $('.login .required').each(function() {
        if($(this).val() === '') {
            error = true;
        }
    });

    if(error) {
        showError('Error', 'Please fill out all required fields');
        return false;
    }
    
    loading('Logging In');
    $.ajax({
        type : 'POST',
        url : $this.attr('action'),
        data : fields,
        dataType : 'json',
        success : function(data) {
            console.log(data);
            unloading();

            if(!data.success) {
                showError('Error', data.message);
                return false;
            }

            // reload the page on success
            window.location.reload();
        },
        error : function(request) {
            console.log(request.responseText);
        }
    });

    return false;
});

// submitting the forgot-password form
$('body').on('submit', '.forgot-password form', function() {
    var $this = $(this);
    var fields = $this.serializeArray();
    fields[fields.length] = { name: '_token', value: $('meta[name="csrf-token"]').attr('content') };
    
    var error = false;

    $('.forgot-password .required').each(function() {
        if($(this).val() === '') {
            error = true;
        }
    });

    if(error) {
        showError('Error', 'Please fill out all required fields');
        return false;
    }
    
    loading();
    $.ajax({
        type : 'POST',
        url : $this.attr('action'),
        data : fields,
        dataType : 'json',
        success : function(data) {
            console.log(data);
            unloading();

            if(data.success) {
                closeModal();
                $('.forgot-password form')[0].reset();
            }

            showError(data.success ? 'Success' : 'Error', data.message);
        },
        error : function(request) {
            console.log(request.responseText);
        }
    });

    return false;
});

// submitting the reset-password form
$('body').on('submit', '.reset-password form', function() {
    var $this = $(this);
    var fields = $this.serializeArray();
    fields[fields.length] = { name: '_token', value: $('meta[name="csrf-token"]').attr('content') };
    
    var error = false;

    $('.reset-password .required').each(function() {
        if($(this).val() === '') {
            error = true;
        }
    });

    if(error) {
        showError('Error', 'Please fill out all required fields');
        return false;
    }
    
    loading();
    $.ajax({
        type : 'POST',
        url : $this.attr('action'),
        data : fields,
        dataType : 'json',
        success : function(data) {
            console.log(data);
            unloading();

            if(!data.success) {
                showError('Error', data.message);
                return false;
            }

            // reload the page on success
            window.location.reload();
        },
        error : function(request) {
            console.log(request.responseText);
        }
    });

    return false;
});

// agree to terms

$('body').on('submit', '.agree-to-terms form', function() {
    var $this = $(this);
    var fields = $this.serializeArray();
    fields[fields.length] = { name: '_token', value: $('meta[name="csrf-token"]').attr('content') };
    
    var error = false;
    var card = $this.parents('.card');
    card.find('.required').each(function() {
        var input = $(this);

        if(input.attr('type') === 'radio') {
            if(!card.find('input[name="'+input.attr('name')+'"]:checked').length) {
                error = true;
            }
        }

        if(input.attr('type') === 'checkbox') {
            if(!input.prop('checked')) {
                error = true;
            }
        }

        if(input.val() === '') {
            error = true;
        }
    });

    if(error) {
        showError('Error', 'Please fill out all required fields');
        return false;
    }
    
    loading();
    $.ajax({
        type : 'POST',
        url : $this.attr('action'),
        data : fields,
        dataType : 'json',
        success : function(data) {
            console.log(data);
            unloading();

            if (!data.success) {
                showError('Error', data.message);
                return false;
            }

            // reload the page on success
            window.location.reload();
        },
        error : function(request) {
            console.log(request.responseText);
        }
    });

    return false;
});